import styles from './ForOrganizers.module.css';
import toutes from '../assets/toutes_white.png';
import newsletter from '../assets/send_white.png';
import heart from '../assets/heart.png';
import instagram from '../assets/instagram.png';
import { Helmet } from 'react-helmet-async';

export default function ForOrganizers() {

    const title = "Pour les organisateurs d’événements à Québec | Alentours";
    const description = "Vous organisez des événements à Québec ? Alentours est une plateforme locale indépendante qui recense et met en valeur les événements culturels et communautaires.";


    return <div className={[styles.page, styles.organizers].join(' ')}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
        <section className={styles.hero}>
            <h1>Tu organises des événements à Québec ?</h1>
            <p>On t'aide à les rendre visibles.
                alentours est une plateforme locale indépendante qui recense et met en valeur les événements culturels, musicaux et communautaires à Québec et dans les environs.
            </p>
        </section>
        <br />
        <hr />
        <br />
        <section>
            <p>
                <strong>Chaque semaine, on :</strong>
                <ul>
                    <li>recense les événements à venir dans la région</li>

                    <li>sélectionne des événements coups de cœur</li>

                    <li>partage ces découvertes sur notre site et dans notre infolettre hebdomadaire (communauté en croissance)</li>
                </ul>
                <br />
                Notre approche est éditoriale, humaine et sélective : on privilégie la pertinence et la qualité plutôt que la quantité.

            </p>
        </section>
        <section>
            <h2>Comment ton événement peut être mis en valeur</h2>
            <p>

                Selon le format et la pertinence, un événement peut bénéficier de :
            </p>
            <div className={styles.grid}>
                <div><img src={toutes} alt="calendrier" /> son inclusion dans le calendrier</div>

                <div><img src={heart} alt="heart" />une mise en avant comme événement coup de cœur</div>

                <div><img src={newsletter} alt="infolettre" />une mention dans l’infolettre hebdomadaire</div>

                <div><img src={instagram} alt="instagram" />une visibilité sur nos réseaux sociaux</div>
            </div>
            <br /><br />

        </section>
        <section className={styles.partners}>
            <h2>À propos des partenariats</h2>
            <p>

                On travaille actuellement avec un nombre limité d’organisateurs et de lieux dans le cadre de partenariats pilotes.

                Ces partenariats permettent une visibilité accrue (mise en avant, infolettre, réseaux sociaux), en complément de la visibilité éditoriale gratuite.
                La sélection des événements coups de cœur demeure toujours indépendante.
            </p>
        </section>
        <section className={styles.contact}>
            <h2>Nous contacter</h2>

            <p>
                Tu souhaites proposer un événement ou en savoir plus ? <br />
                📩 <a href="mailto:contact@alentours.ca">contact@alentours.ca</a>
                <br/>
                L’inscription des événements au calendrier est gratuite.
            </p>
            <button className={styles.button} type="button"><a href="mailto:contact@alentours.ca">Écris-nous</a></button>

        </section>
        <br /><br /><br />
    </div>;
};